export const createNews = (newsItem) => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const firebase = getFirebase();
        const firestore = getFirebase().firestore();

        return firestore.collection('/news')
            .doc()
            .set({
                created: firebase.firestore.FieldValue.serverTimestamp(),
                updated: firebase.firestore.FieldValue.serverTimestamp(),
                ...newsItem
            }).then(() => {
                dispatch({ type: 'CREATE_NEWS', newsItem });
            }).catch((err) => {
                dispatch({ type: 'CREATE_NEWS_ERROR', err });
                throw err;
            })
    }
}

export const updateNews = (newsItem) => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const firebase = getFirebase();
        const firestore = getFirebase().firestore();

        return firestore.collection('/news')
            .doc(newsItem.id)
            .update(
                {
                    updated: firebase.firestore.FieldValue.serverTimestamp(),
                    ...newsItem
                },
                { merge: true }
            ).then(() => {
                dispatch({ type: 'UPDATE_NEWS', newsItem });
            }).catch((err) => {
                dispatch({ type: 'UPDATE_NEWS_ERROR', err });
                throw err;
            })
    }
}

export const deleteNewsItem = (newsItem) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const firestore = getFirebase().firestore();

        return firestore.collection('/news')
            .doc(newsItem.id)
            .delete()
            .then(() => {
                dispatch({ type: 'DELETE_NEWS', newsItem });
            }).catch((err) => {
                dispatch({ type: 'DELETE_NEWS_ERROR', err });
                throw err;
            })
    }
}
